<script setup lang="ts">
definePage({
	name: "admin.dashboard",
	meta: {
		permissions: "view-dashboard",
	},
});
</script>

<template>
	<div>
		<h1>Dashboard</h1>
	</div>
</template>

<style scoped lang="scss"></style>
